export function formatAppBuildLabel({ environmentLabel, version }) {
  const label = String(environmentLabel || "").trim();
  const buildVersion = String(version || "").trim();

  return [label, buildVersion ? `v${buildVersion}` : ""]
    .filter(Boolean)
    .join(" ");
}

export const appBuildLabel = formatAppBuildLabel({
  environmentLabel: process.env.REACT_APP_ENVIRONMENT_LABEL,
  version: process.env.REACT_APP_APP_VERSION,
});
